import { render, staticRenderFns } from "./OrganismServerInformation.vue?vue&type=template&id=2c090356&scoped=true&"
import script from "./OrganismServerInformation.vue?vue&type=script&lang=js&"
export * from "./OrganismServerInformation.vue?vue&type=script&lang=js&"
import style0 from "./OrganismServerInformation.vue?vue&type=style&index=0&id=2c090356&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c090356",
  null
  
)

export default component.exports